import { render, staticRenderFns } from "./DispatchAlertDetailsView.vue?vue&type=template&id=583f2587"
import script from "./DispatchAlertDetailsView.vue?vue&type=script&lang=js"
export * from "./DispatchAlertDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports